import React, { useCallback, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { SnackBarClose } from "assets/images/SnackbarClose";

interface OmronSnackBarProps extends OmronSnackBarColorProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  duration?: number;
}

interface OmronSnackBarColorProps {
  color?: OmronSnackBarColor;
}

export type OmronSnackBarColor = "info" | "success" | "warn" | "error";

const OmronSnackBar = ({
  isOpen,
  onClose,
  message,
  duration,
  color,
}: OmronSnackBarProps): JSX.Element => {
  const timer = useRef(0);
  const onTimeOutHandler = useCallback(() => {
    timer.current = window.setTimeout(() => onClose(), duration);
  }, [onClose, duration]);

  const onCloseHandler = useCallback(() => {
    clearTimeout(timer.current);
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (duration !== 0) {
      onTimeOutHandler();
    }
    return () => {
      clearTimeout(timer.current);
    };
  }, [duration, onTimeOutHandler]);

  return isOpen ? (
    <Ancher>
      <Container color={color}>
        {message}
        <SnackBarClose onClick={onCloseHandler} />
      </Container>
    </Ancher>
  ) : (
    <div />
  );
};

OmronSnackBar.defaultProps = {
  duration: 0,
  color: "error",
};

export default OmronSnackBar;

// syle

const Ancher = styled.div`
  top: 0;
  display: inline-block;
  width: 800px;
  text-align: center;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  background: #ffffff;
  box-shadow: 0 0 8px #999999;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  z-index: 6;
`;

const Container = styled.p<OmronSnackBarColorProps>`
  white-space: pre-wrap;
  svg {
    width: 1rem;
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
    :hover {
      cursor: pointer;
    }
  }
  ${(props) => {
    if (props.color === "info" || props.color === "success") {
      return css`
        padding: 2rem 1rem;
        line-height: 1.4;
        background: rgba(18, 133, 80, 0.08);
      `;
    }
    return css`
      padding: 2rem 1rem;
      color: #e50000;
      line-height: 1.4;
      background: rgba(229, 0, 0, 0.08);
      position: relative;
    `;
  }}
`;
